'use client';

import { useEffect } from 'react';
import {
  brandIsPw,
  getCurrentBrand,
} from '@/shared/config/brand-by-target.mjs';

// const BEACON_PATH = '/public/health/reachability-beacon';
const BEACON_URL = 'https://pingwin.live/public/health/reachability-beacon';

const RedirectRouterArrivalBeacon = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const projectCode =
      params.get('rr_project_code') ||
      (brandIsPw ? 'pingwin' : getCurrentBrand());
    const domainId = params.get('rr_domain_id');
    const hostname = params.get('rr_hostname') || window.location.hostname;
    const requestId = params.get('rr_request_id');

    if (!projectCode || (!domainId && !hostname)) {
      return;
    }

    const fire = () => {
      const beacon = new URL(BEACON_URL);
      beacon.searchParams.set('project_code', projectCode);
      if (domainId) {
        beacon.searchParams.set('domain_id', domainId);
      } else {
        beacon.searchParams.set('hostname', hostname);
      }
      if (requestId) {
        beacon.searchParams.set('request_id', requestId);
      }

      const image = new Image(1, 1);
      image.referrerPolicy = 'no-referrer';
      image.src = beacon.toString();
    };

    requestAnimationFrame(fire);
  }, []);

  return null;
};

export { RedirectRouterArrivalBeacon };
